import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=0a40b0a1&scoped=true&lang=pug&"
import script from "./Password.vue?vue&type=script&lang=ts&"
export * from "./Password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40b0a1",
  null
  
)

export default component.exports